export default {
  // 模式
  "common.mode.auto": "מצב שימוש עצמי באנרגיה מחוללת עצמית",
  "common.mode.economy": "מצב כלכלי",
  "common.mode.exigency": "מצב חירום",

  // 设备
  "common.grid": "רשת חשמל",
  "common.evChargers": "מטענים למכוניות חשמל",
  "common.evCharger": "מטען למכונית חשמל",
  "common.pv": "פוטו-וולטאית (PV)",
  "common.inverter": "מהפך מתח",
  "common.pcs": "מהפך מתח + סוללה",
  "common.terminal": "מכשיר מסוף",
  "common.airc": "מחשב מין (מתקרר)",
  "common.engine": "מנוע",
  "common.battery": "סוללה",
  "common.metter": "מדד חשמל",
  "common.other": "אחר",
  "common.power": "עוצמה",
  "common.powerTotal": "עוצמה כוללת",
  "common.voltage": "מתח",
  "common.electricity": "אנרגיה חשמלית",
  "common.current": "זרם",
  "common.homeUsage": "עומס כולל של הבית",
  "common.battery.power": "עוצמת הסוללה",

  // 数据
  "common.noDataAvailable": "אין נתונים זמינים כעת~",
  "common.tips": "טיפ",
  "common.reset": "אפס",
  "common.currencyUnit": "¥",
  "common.submiting": "משלח... אנא המתן...",
  "common.close": "סגור",
  "common.from": "מתוך",
  "common.useIn": "לשימוש ב",
  "common.energyPercent": "אחוז זרימת האנרגיה",
  "common.dataFlow": "זרימת נתונים",
  "common.getDataIng": "מקבל נתונים... אנא המתן...",
  "common.pageLoading": "טוען תוכן הדף... אנא המתן...",
  "common.reseting": "מאפס תוכן הדף... אנא המתן...",
  "common.save": "שמור",
  "common.onlyNumberTips": "ניתן להכניס מספרים בלבד",
  "common.offline": "אווירליין (ללא חיבור)",
  "common.online": "אווירליין (עם חיבור)",
  "common.fault": "שגיאה",
  "common.charge": "טעינה",
  "common.discharge": "פריקה (ניקוי מטען)",
  "common.buy": "קנה",
  "common.sell": "מכור",
  "common.loadingInfo": "טוען... אנא המתן...",

  // 通用功能
  "common.moreFeatures": "תכונות נוספות",
  "common.confirm": "אשר",
  "common.saveing": "שומר... אנא המתן...",
  "common.searchPlacholder": "הכנס מילה מפתח לחיפוש",
  "common.iSee": "אני מבין",
  "common.pageErrorTips1": "אוי, שגיאה התרחשה בדף~",
  "common.pageErrorTips2": "נסה לרענן את הדף או ליצור קשר עם תמיכה~",
  "common.refresh": "רענן",
  "common.backToHome": "חזור לעמוד הבית",
  "common.checkTips": "מבדוק... אנא המתן...",
  "common.back": "חזור",
  "common.cancel": "בטל",
  "common.optional": "אופציונלי",
  "common.required": "חובה",
  "common.status": "מצב",
  "common.statusNoDelete": "לא נמחק",
  "common.statusDelete": "נמחק",
  "common.submit": "שלח",
  "common.disable": "בטל פעילות",
  "common.enable": "הפעל",
  "common.year": "שנה",
  "common.month": "חודש",
  "common.day": "יום",
  "common.version": "גרסה:",
  "common.backHome": " חזור לעמוד הבית",
  "common.backHomeSorry": " מצטערים, הדף אבד את הדרך בטעות",
  "common.requestTips1": "עיבוד נתונים בעי� progress, אל תשלח שוב",
  "common.requestTips2": "התראות מערכת",
  "common.requestTips3": "תוקף ההתחברות פג, אנא התחבר שוב",
  "common.requestTips4": "התחבר שוב",
  "common.requestTips5": "פגישה לא חוקית או תוקףיה פג, אנא התחבר שוב.",
  "common.requestTips6": "שגיאת שרת, אנא נסה שוב αργότερα.",
  "common.requestTips7": "תוקף הבקשה לממשק המערכת פג",
  "common.requestTips8": "ממשק המערכת",
  "common.requestTips9": "שגיאה",
  "common.iknow": "אני מבין",
  "common.logoutSuccess": "התנתקות מוצלחת",
  
  //了解更多组件
  "common.knowMore.title": "לקבלת מידע נוסף, אנא ליצור קשר עם Beineng",
  "common.knowMore.email": "דואר אלקטרוני ליצירת קשר",
  "common.knowMore.phone": "טלפון ליצירת קשר",
  "common.knowMore.wechat": "WeChat ליצירת קשר",
  "common.knowMore.website": "כתובת האתר הרשמי",
  "common.knowMore.address": "כתובת ליצירת קשר",
  "common.knowMore.addressDetail": "חדרים 1205, 1301, בניין 5, רחוב צ'ינגה 8, כפר הואנג'צינג'קנג, הואנג'ג'iang, עיר דונג�ुआን, מחוז Гуандун",
  
  //本地连接组件
  "common.localConnection": "חיבור מקומי",
  "common.operateInApp": "ực hiện פעולה באפליקציה!",
  
  "common.enbleStaus": "מצב הפעלה",
  "common.battery.status": "אין טעינה ופריקה",

  //账户相关
  "account.forgetThePassword": "שכחתי סיסמה",
  "account.logInDirectly": "התחברות ישירה",
  "account.tips1": "מעביר לעמוד... אנא המתן...",
  "account.tips2": "ראשית, קרא וקבל את תנאי השימוש!",
  "account.autoLogin": "התחברות אוטומטית",
  "account.userLogin": "התחברות משתמש",
  "account.registerTips": "אין לך עדיין חשבון? לחץ כאן כדי להירשם",
  "account.userEmail": "שם משתמש / דואר אלקטרוני",
  "account.userEmailTips": "הכנס שם משתמש או דואר אלקטרוני",
  "account.password": "סיסמה",
  "account.passwordTips": "הכנס סיסמה",
  "account.submit": "שלח",
  "account.submitTips": "משלח... אנא המתן...",
  "account.otherLoginTips": "או בחר שיטת התחברות אחרת",
  "account.userRegistration": "רישום משתמש",
  "account.userName": "שם משתמש",
  "account.userNameTips": "הכנס שם משתמש",
  "account.emailTips1": "הכנס כתובת דואר אלקטרוני",
  "account.emailTips2": "פורמט דואר אלקטרוני לא חוקי",
  "account.phone": "מספר טלפון",
  "account.phoneTips1": "הכנס מספר טלפון",
  "account.phoneTips2": "מספר טלפון לא חוקי",
  "account.phoneTips3": "הכנס מספר טלפון",
  "account.passwordTips1": "הכנס סיסמה (6-30 תווים)",
  "account.passwordTips2": "פורמט סיסמה לא חוקי: הסיסמה חייבת להכיל אותיות אנגליות, מספרים, קווים תחתונים, קווים אופקיים ונקודות, אורך 6-12 תווים",
  "account.passwordTips3": "שתי הסיסמאות שהוכנסו אינן תואמות, אנא בדוק והכנס שוב!",
  "account.passwordTips4": "הכנס סיסמה: הסיסמה חייבת להכיל אותיות אנגליות, מספרים, קווים תחתונים, קווים אופקיים ונקודות",
  "account.passwordTips5": "אישור סיסמה",
  "account.passwordTips6": "הכנס אישור סיסמה",
  "account.passwordTips7": "שתי הסיסמאות שהוכנסו אינן תואמות, אנא בדוק והכנס שוב!",
  "account.passwordTips8": "הכנס אישור סיסמה",
  "account.passwordTips9": "מזל טוב, הרישום מוצלח!",
  "account.passwordTips10": "שם המשתמש שלך הוא:",
  "account.emailIs": "דואר אלקטרוני הוא:",
  "account.goToLoginPage": "בתוך s שניות תעבור אוטומטית לעמוד התחברות",
  "account.goLogin": "התחבר",
  "account.goRegister": "הירשם",
  "account.loginSuccess": "התחברות מוצלחת",
  "account.email": "דואר אלקטרוני",
  "account.sologn": "אנחנו יוצרים תוכנית אנרגיה מותאמת אישית עבורך בזהירות רבה",
  "account.pleaseAgree": "קראתי קיבלתי את",
  "userAgreement.privacyPolicy": "מדיניות הפרטיות",

  //验证码相关
  "account.code": "קוד אימות",
  "account.codeTips": "הכנס קוד אימות",
  "account.codeTips2": "קוד אימות לא חוקי",

    "account.inviteCodeTips": "אנא הזן קוד הזמנה",
    "account.inviteCodeHint": "אנא צור קשר עם המתקין או צוות התפעול והתחזוקה לקבלת קוד ההזמנה",
  //密码修改与恢复
  "account.modifyPasswordByAccount": "שינוי סיסמה דרך חשבון",
  "account.modifyPasswordByEmail": "שינוי סיסמה דרך דואר אלקטרוני",
  "account.getPasswordByAccount": "קבלת סיסמה דרך חשבון",
  "account.getPasswordByEmail": "קבלת סיסמה דרך דואר אלקטרוני",

  "account.sendEmailTips": "קוד האימות נשלח לדואר אלקטרוני, אנא בדוק",
  "account.name": "שם החשבון",
  "account.newPassword": "סיסמה חדשה",
  "account.confirmNewPassword": "אישור סיסמה חדשה",
  "account.nameTips": "הכנס שם החשבון",
  "account.passwordModifySuccess": "שינוי סיסמה מוצלח",
  "account.emailCode": "קוד אימות דואר אלקטרוני",
  "account.emailCodeTips": "הכנס קוד אימות דואר אלקטרוני",
  "account.emailCodeTips2": "קוד אימות דואר אלקטרוני לא חוקי",
  "account.emailModifySuccess": "שינוי סיסמה מוצלח",
  "account.passworTips1": "הסיסמה שלך אופסה בהצלחה!",
  "account.passwordTips11": "הכנס אישור סיסמה",
  "account.passwordTips12": "הכנס סיסמה חדשה",
  "account.nickname": "כינוי משתמש",
  "account.modifyNickname": "שינוי כינוי משתמש",
  "account.modifyNicknameSuccess": "שינוי כינוי משתמש מוצלח!",
  "account.nicknameTips": "הכנס כינוי משתמש",
  "account.nicknameError": "שינוי כינוי משתמש לא מוצלח!",

  //快速注册与登录
  "account.login": "התחבר",
  "account.quickRegister": "רישום מהיר",
  "account.sendCode": "שלח קוד אימות",
  "account.sendTips": "ניתן לשלח שוב בתוך s שניות",
  "account.sendEmailIng": "משלח דואר אלקטרוני... אנא המתן...",
  "account.emailNotEmpty": "כתובת דואר אלקטרוני לא יכולה להיות ריקה",
  "account.registerAccount": "רישום חשבון",
  "account.registerWelcome": "ברוך הבא לרישום SusprSafe",
  "account.usernameLimit": "שם המשתמש חייב להתחיל עם אות וניתן להכיל אותיות, מספרים וקווים תחתונים בלבד, אורך 5-15 תווים",

  //版权信息
  "copyright.desc2": "מידע על רישום האתר: רישום ICP Гуандун מספר 2021169764",

  //用户信息编辑
  "editUserInfo.editUserInformation": "עריכת מידע משתמש",
  "editUserInfo.modifyUsername": "שינוי שם משתמש",
  "editUserInfo.changePictures": "שינוי תמונת פרופיל",
  "editUserInfo.savePicturesSuccess": "תמונת פרופיל המשתמש נשמרה בהצלחה",
  "editUserInfo.saveError": "שמירה לא מוצלחת",
  "editUserInfo.pictureLimit": "גודל התמונה חייב להיות קטן מ-2 מגה-בייט",
  "editUserInfo.uploadPicture": "העלה תמונת פרופיל",
  "editUserInfo.picturePreview": "תצוגה מקדימה",
  
  "editUserInfo.bindPhoneNumber": "קישור מספר טלפון",
  "editUserInfo.bindEmail": "קישור דואר אלקטרוני",
  "editUserInfo.changePassword": "שינוי סיסמה",

  "editUserInfo.notificationSettings": "הגדרות התראות",
  "editUserInfo.editAccount": "עריכת מידע חשבון משתמש",
  "editUserInfo.waitBingting": "מקשר... אנא המתן...",
  "editUserInfo.collapse": "צמצם",
  "editUserInfo.modifyBinding": "שינוי קישור",
  
  "editUserInfo.emailAddress": "כתובת דואר אלקטרוני",
  "editUserInfo.tips1": "דואר אלקטרוני מקושר בהצלחה",
  "editUserInfo.tips2": "שמירה לא מוצלחת",
  "editUserInfo.tips3": "משלח קוד אימות דואר אלקטרוני... אנא המתן...",
  "editUserInfo.tips4": "קוד האימות נשלח לדואר אלקטרוני xxxx, אנא בדוק",
  "editUserInfo.tips5": "שליחת קוד אימות לא מוצלחת!",
  "editUserInfo.tips6": "מספר הטלפון כבר מקושר",
  "editUserInfo.tips7": "הדואר האלקטרוני כבר מקושר",
  "editUserInfo.emailTips1": "הכנס כתובת דואר אלקטרוני",
  "editUserInfo.emailTips2": "פורמט דואר אלקטרוני לא חוקי",
  "editUserInfo.emailTips3": "ניתן לשלח שוב בתוך xxxx שניות",
  "editUserInfo.emailTips4": "שלח קוד אימות",
  "editUserInfo.emailTips5": "קוד אימות דואר אלקטרוני לא יכול להיות ריק",
  "editUserInfo.emailTips6": "קוד אימות דואר אלקטרוני לא חוקי",
  "editUserInfo.emailCode": "קוד אימות דואר אלקטרוני",
  "editUserInfo.save": "שמור",

  //手机绑定相关
  "editUserInfo.phoneTips1": "מספר הטלפון מקושר בהצלחה",
  "editUserInfo.phoneTips2": "משלח קוד אימות SMS... אנא המתן...",
  "editUserInfo.phoneTips3": "קוד אימות SMS נשלח למספר טלפון xxxx, אנא בדוק",
  "editUserInfo.phoneTips4": "שליחת קוד אימות SMS לא מוצלחת!",
  "editUserInfo.phoneTips5": "הכנס מספר טלפון",
  "editUserInfo.phoneTips6": "פורמט מספר טלפון לא חוקי",
  "editUserInfo.phoneTips7": "שלח קוד אימות SMS",
  "editUserInfo.phoneTips8": "קוד אימות SMS",
  "editUserInfo.phoneTips9": "קוד אימות SMS לא יכול להיות ריק",
  "editUserInfo.phoneTips10": "קוד אימות SMS לא חוקי",
  "editUserInfo.phone": "מספר טלפון",


  //通知设置
  "editUserInfo.noticeTips1": "קבלת הגדרות התראות לא מוצלחת!",
  "editUserInfo.noticeTips2": "הגדרות התראות נשמרה בהצלחה!",
  "editUserInfo.noticeTips3": "התראה על רמה נמוכה של סוללה",
  "editUserInfo.noticeTips4": "התראה על סיום טעינת המטען",
  "editUserInfo.errorNotification": "התראה על שגיאה",
  "editUserInfo.updateNotification": "התראה על עדכון",
  "editUserInfo.monthlyStatisticsNotification": "התראה על סטטיסטיקה חודשית",
  "editUserInfo.notificationMethod": "דרך קבלה",

  //用户名相关提示
  "editUserInfo.userNameTips1": "שם המשתמש נשמרה בהצלחה",
  "editUserInfo.userNameTips2": "שמירת שם המשתמש לא מוצלחת",
  "editUserInfo.userNameTips3": "הכנס שם המשתמש",
  "editUserInfo.userNameTips4": "פורמט שם המשתמש לא חוקי: יכול להכיל מספרים, קווים תחתונים ואותיות אנגליות בלבד",
  "editUserInfo.userNameTips5": "הכנס שם המשתמש",
  "editUserInfo.userNameTips6": "שומר... אנא המתן...",
  "editUserInfo.userName": "שם משתמש",

  //头像编辑提示
  "editUserInfo.avatorTips": "לחץ כדי לשנות תמונת פרופיל",
  "editUserInfo.verifyCodeTips1": "הכנס את קוד האימות שהתקבל:",
  "editUserInfo.verifyCodeTips2": "למען בטיחות החשבון שלך, לחץ על הכפתור למטה כדי לשלוח קוד אימות למספר הטלפון המקורי:",
  "editUserInfo.verifyCodeTips3": "שלח קוד אימות",
  "editUserInfo.verifyCodeTips4": "אימות מספר הטלפון המקורי מוצלח, הכנס מספר טלפון מקושר חדש",
  "editUserInfo.verifyCodeTips5": "למען בטיחות החשבון שלך, לחץ על הכפתור למטה כדי לשלוח קוד אימות לדואר האלקטרוני המקורי:",
  "editUserInfo.verifyCodeTips6": "אימות דואר האלקטרוני המקורי מוצלח, הכנס דואר אלקטרוני חדש",
  "editUserInfo.verifyCodeTips7": "סיסמה ישנה",
  "editUserInfo.verifyCodeTips8": "ראשית, קשור דואר אלקטרוני!",
  "editUserInfo.verifyCodeTips9": "קוד האימות נשלח לדואר אלקטרוני, אנא בדוק",
  "editUserInfo.verifyCodeTips10": ", תעבור אוטומטית לעמוד התחברות",

  //通知相关
  "hems.notice.title": "כותרת התראה", 
  "hems.notice.content": "תוכן התראה", 
  "hems.notice.operate": "פעולה",
  "hems.notice.noRead": "לא נקרא",
  "hems.notice.read": "נקרא",
  "hems.notice.warning": "אזהרה",
  "hems.notice.error": "שגיאה",
  "hems.notice.success": "חישוב סטטיסטיקה",
  "hems.notice.sys": "מידע מערכת",
  "hems.notice.operateSuccess": "פעולה מוצלחת",
  "hems.notice.operateTips": "בחר אלמנט לפעולה",

  // 首页
  "hems.home.selfuseRate": "אחוז שימוש עצמי",
  "hems.home.percent": "אחוז",
  "hems.home.todayData": "נתונים של היום",
  "hems.home.todayPowerGeneration": "ייצור אנרגיה של היום",
  "hems.home.salesIncome": "הכנסה ממכירת אנרגיה",
  "hems.home.saved": "חסכת אתה",
  "hems.home.reduce": "הפחתת עקבות פחמן",
  "hems.home.tips1": "אין נתונים זמינים כעת, אתה עדיין לא קשרت xxxx",
  "hems.home.criticalLoad": "עומס קריטי",
  "hems.home.keyVoltage": "מתח קריטי",
  "hems.home.householdLoad": "עומס הבית",
  "hems.home.householdVoltage": "מתח הבית",
  "hems.home.generalLoad": "עומס כללי",
  "hems.home.generalVoltage": "מתח כללי",
  "hems.home.batteryHealth": "מצב בריאות הסוללה",
  "hems.home.averageTemp": "טמפרטורה ממוצעת",
  "hems.home.gridLoad": "עומס הרשת החשמלית",
  "hems.home.toggeleDataSource": "הנתונים המוצגים כעת השתנו ל:",
  "hems.home.toggleTips": "האם אתה בטוח שתרצה לשנות?",
  "hems.home.modeSending": "משלח פקודת מצב... אנא המתן...",
  "hems.home.modeSuccess": "פקודת שינוי מצב נשלחה בהצלחה!",
  "hems.home.isOnline": "�ออนไลน�?",
  "hems.home.useStatus": "מצב שימוש",
  "hems.home.workModeText": "מצב עבודה נוכחי:",
  "hems.home.toggleDataSourceText": "הנתונים המוצגים כעת השתנו ל:",
  "hems.ev.charge.status": "מצב טעינה",
  "hems.ev.charge.time": "זמן טעינה",
  "hems.ev.charge.count": "כמות טעינה בזמן אמת",
  "hems.ev.charge.status.empty": "ריק",
  "hems.ev.charge.status.ing": "מטען עם כבל מחובר",
  "hems.ev.charge.status.null": "הכבל מחובר אך אין טעינה",
  "hems.ev.charge.status.error": "שגיאה",
  "hems.hour": "שעה",
  "hems.minue": "דקה",
  "hems.ev.chagre.number": "מספר המטען",

  // 用户指南
  "hems.userGuide.selfUse": "שימוש עצמי באנרגיה מחוללת עצמית",
  "hems.userGuide.selfUseTips": "השתמש תחילה באנרגיה פוטו-וולטאית, אם אין מספיק, השלים מן הרשת החשמלית",
  "hems.userGuide.economyMode": "מצב כלכלי",
  "hems.userGuide.economyModeTips": "אופטימיזציה של אסטרטגיית שימוש באנרגיה לפי מחיר האנרגיה החשמלית",
  "hems.userGuide.emergencyMode": "מצב חירום",
  "hems.userGuide.emergencyModeTips": "השאר את אספקת האנרגיה לעומס הקריטי תחילה",

  // 图表页面
  "hems.history.energyStatistics": "סטטיסטיקה אנרגיה",
  "hems.history.revenueStatistics": "סטטיסטיקה הכנסות",
  "hems.history.greenStatistics": "הפחתת פליטות ירוקות",
  "hems.history.revenueTitle": "הכנסה כוללת ממכירת אנרגיה",
  "hems.history.savingsTitle": "חסכון כולל",
  "hems.history.carbonTitle": "הפחתת פחמן כוללת",
  "hems.history.day": "יום",
  "hems.history.month": "חודש",
  "hems.history.year": "שנה",
  "hems.history.beforeDay": "יום קודם",
  "hems.history.afterDay": "יום הבא",
  "hems.history.beforeMonth": "חודש קודם",
  "hems.history.afterMonth": "חודש הבא",
  "hems.history.beforeYear": "שנה קודמת",
  "hems.history.afterYear": "שנה הבאה",
  "hems.history.totalUse": "שימוש כולל",
  "hems.history.fullScreen": "מסך מלא",
  "hems.history.timeSelect": "בחירת תאריך",
  "sync.tips1": "פקודת סינכרונציה נתונים נשלחה בהצלחה!",
  "sync.tips2": "סינכרונציה נתונים בעי� progress, בגלל נפח נתונים גדול נדרש זמן, בדוק שוב אחרי חצי שעה~",
  "sync.tips3": "סינכרונציה נתונים של המכשיר עלולה להיות עם עיכוב, אם תבחין בחוסר התאמה בנתונים, לחץ על:",
  "sync.tips4": "סינכרוני נתונים",

  // 充电桩信息
  "charge.info": "מידע על המטען",
  "news.loading": "טוען...",
  "news.noMore": "אין יותר נתונים",
  "hems.pv.power": "כמות אנרגיה פוטו-וולטאית",

  // UEH特定功能
  "ueh.sellPower": "כמות אנרגיה מכורה",
  
  // 菜单
  "menu.home": "עמוד הבית",
  "menu.history": "נתונים היסטוריים",
  "menu.device": "מכשירים",
  "menu.settings": "הגדרות",
  "menu.messageCenter": "מרכז הודעות",
  "menu.help": "עזרה ותמיכה",
  "menu.mine": "שלי",


  // 我的设置
  "mine.userSetting": "הגדרות משתמש",
  "mine.terminalSetting": "הגדרות בסיסיות של המסוף",
  "mine.uploadCloud": "העלה נתונים לענן",
  "mine.changeVersion": "בדוק עדכון",
  "mine.language": "שנה שפה",
  "mine.about": "עליהאפליקציה",
  "mine.feedback": "משוב",
  "mine.logout": "התנתק",
  "mine.logoutAccount": "מחק חשבון",

  // 注销账户相关
  "mine.logoutAccountTips": "מחק חשבון בשם []",
  "mine.logoutAccountTips1": "מחק חשבון המקושר ל []",
  "mine.logoutAccountCare": "הערות לבקשה למחיקת חשבון:",
  "mine.logoutAccountCare1": "1. החשבון נמצא במצב בטוח",
  "mine.logoutAccountCare1-1": "החשבון נמצא במצב שימוש רגיל, אין סיכון לגניבה, הפרה של חוקים או חסימה.",
  "mine.logoutAccountCare2": "2. הרשמות וקישורים של החשבון הוסרה",
  "mine.logoutAccountCare2-1": "כל הרשמות של החשבון עם פלטפורמות של צדדים שלישיים הוסרה.",
  "mine.logoutAccountCare3": "3. לאחר מחיקת החשבון אין δυνατότητα שחזורו, נתוני המשתמש יוסרו",
  "mine.logoutAccountCare3-1": "לאחר מחיקת החשבון, מספרי הטלפונים המקושרים, הדואר האלקטרוני ונתונים אחרים יוסרו ואין δυνατότητα שחזורهم.",
  "mine.confirmLogout": "אשר מחיקה",
  "mine.logoutSuccess": "החשבון נמחק בהצלחה!",


  // 反馈问题
  "mine.feedbackIssues": "משוב על בעיות",
  "mine.feedQuantity": "כמות",
  "mine.feedAmount": "מקסימום 9 תמונות, גודל מקסימלי 1 מגה-בייט לתמונה",

  // 通知设置相关
  "mine.notice.fail": "קבלת הגדרות התראות לא מוצלחת!",
  "mine.notice.saveSuccess": "הגדרות התראות נשמרה בהצלחה!",
  "mine.notice.saveFail": "שמירה לא מוצלחת!",
  "mine.notice.title": "הגדרות התראות",
  "mine.notice.batteryLow": "התראה על רמה נמוכה של סוללה",
  "mine.notice.chargingFinish": "התראה על סיום טעינת המטען",
  "mine.notice.error": "התראה על שגיאה",
  "mine.notice.update": "התראה על עדכון",
  "mine.notice.monthly": "התראה על סטטיסטיקה חודשית",
  "mine.notice.receiveType": "דרך קבלה",

  // 语言设置欢迎语
  "mine.language.welcome": "ברוך הבא ל-SusprSafe",
  "mine.language.desc1": "בחר גרסת שפה לפי מקום המגורים שלך",
  "mine.language.desc2": "אתה יכול לשנות אותה בכל זמן בהגדרות האפליקציה",

  // 个人信息
  "mine.userInfo.avatar": "תמונת פרופיל",
  "mine.userInfo.nickname": "כינוי",
  "mine.userInfo.password": "סיסמה",
  "mine.userInfo.changePassword": "שינוי סיסמה",
  "mine.userInfo.setPassword": "הגדר סיסמה",
  "mine.userInfo.phoneNumber": "מספר טלפון",
  "mine.userInfo.bindPhone": "קשור מספר טלפון",
  "mine.userInfo.bindEmail": "קשור דואר אלקטרוני",
  "mine.loginExpired": "תוקף ההתחברות פג, אנא התחבר שוב",
  "mine.userInfo.title": "מידע משתמש",
  "mine.userInfo.bind": "קשור",
  "mine.userInfo.modify": "ערוך",
  "mine.userInfo.modifyNickname": "שינוי כינוי",
  "mine.userInfo.userNickname": "כינוי משתמש",
  "mine.userInfo.selectPic": "בחר תמונה להעלאה",
  "mine.userInfo.saveSuccess": "שמירה מוצלחת",
  "mine.userInfo.uploadFail": "העלאה לא מוצלחת",
  "mine.userInfo.avatarSaveSuccess": "תמונת פרופיל נשמרה בהצלחה",
  "mine.userInfo.nameTips1": "כינוי משתמש לא יכול להיות ריק",
  "mine.userInfo.nameTips2": "הכנס כינוי משתמש",

  // 通用选择提示
  "common.pleaseSelect": "אנא בחר",
  "question.commonQuestions": "שאלות נפוצות",
  "account.toggleLanguage": "שנה שפה",
  "account.localConnection": "חיבור מקומי",
  "account.selectLanguage": "אנא בחר שפה",
  "account.sendEmailToast": "קוד האימות נשלח לדואר אלקטרוני xxx, אנא בדוק",
  "account.emailError": "פורמט דואר אלקטרוני לא חוקי",
  "account.sendEmailFail": "שליחה לא מוצלחת, אנא נסה שוב",
  
  "common.submitting": "משלח... אנא המתן...",

  "device.page.noData": "אין נתונים זמינים כעת, הדף הזה ניתן לצפות בו רק באפליקציה"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};